import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown'

import { AllowanceCharge } from '../../data/models'
import i18n from '../../utils/i18n'

export const AlcTypeFilterTemplate = (options: any) => {
  if (!options) return null

  const alcTypes: AllowanceCharge['AlcType'][] = ['Surcharge', 'Discount']

  const valueTemplate = (option: AllowanceCharge['AlcType'], props: any) => {
    if (option) {
      return (
        <>
          {option === 'Surcharge'
            ? i18n.t('common.codes.alcType.surcharge')
            : i18n.t('common.codes.alcType.discount')}
        </>
      )
    }

    return <>{props.placeholder}</>
  }

  const itemTemplate = (option: AllowanceCharge['AlcType']) =>
    option === 'Surcharge'
      ? i18n.t('common.codes.alcType.surcharge')
      : i18n.t('common.codes.alcType.discount')

  return (
    <Dropdown
      value={options.value}
      options={alcTypes}
      onChange={(e: DropdownChangeEvent) =>
        options.filterCallback(e.value, options.index)
      }
      valueTemplate={valueTemplate}
      itemTemplate={itemTemplate}
      className="p-column-filter"
      placeholder={i18n.t('common.placeholders.searchType')}
    />
  )
}
